export default import.meta.ROLLUP_FILE_URL_D2ISk4a6;